export default __webpack_public_path__ + "static/citroenist_2-03667352b66adf4f00ecf99677429f19.webp";